<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	const {
		count,
		total,
		...rest
	}: { count: number; total: number } & HTMLAttributes<HTMLDivElement> = $props();
</script>

<div
	{...rest}
	class={['mt-4 mb-8 h-1 w-full rounded-xl bg-gray-300', rest.class]}
	style:--progress={`${((count / total) * 100).toFixed(0)}%`}
>
	<div
		class="ease h-full w-[var(--progress)] rounded-xl bg-black transition-[width] duration-300"
	></div>
</div>
